import React from "react";
import { Image, Grid } from 'semantic-ui-react';
import noDataImage from "../../../../images/common/no_data_image.svg";

class SystemNotification extends React.Component {

    render() {

        return (

            <Grid className="notificationPane">
                <Grid.Row columns={1} className="fixBlock" >
                    <div className="noUpdates">
                        <Image src={noDataImage} />
                        <h3>That's all. No more updates.</h3>
                    </div>
                </Grid.Row>
            </Grid>

        );
    }
}
export default SystemNotification;
